module.exports = __webpack_public_path__ + "img/demo_01.642dd981.jpg";